export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    couponGroupList: [
      {
        couponGroupIdx: 1,
        couponGroupName: "10%",
      },
      {
        couponGroupIdx: 2,
        couponGroupName: "20%",
      },
      {
        couponGroupIdx: 3,
        couponGroupName: "모바일오더 쿠폰",
      },
      {
        couponGroupIdx: 4,
        couponGroupName: "무료 쿠폰",
      },
      {
        couponGroupIdx: 5,
        couponGroupName: "머그사용",
      },
      {
        couponGroupIdx: 6,
        couponGroupName: "10회 스템프 무료",
      },
    ],
  },
};
